export enum AgeTypes {
  NewestToOldest = 'Newest to Oldest',
  OldestToNewest = 'Oldest to Newest',
}
